<!--设备一览列表-->
<template>
  <div>
    <div class="content-header" style="border: none">
      <div class="left">
        <span class="title">设备列表</span>
      </div>
      <div class="right">
        <Button
          type="success"
          style="margin-right: 10px"
          @click="syncMachine"
          :loading="syncStatus"
          >同步设备</Button
        >
        <Button type="primary" style="z-index: 1" @click="addMachine">新增设备</Button>
      </div>
    </div>
    <!--  <Tabs class="list-tab" v-model="tab_val" @on-click="typeClick">
      <TabPane label="云知印" name="0"></TabPane>
      <TabPane label="云知印mini" name="3"></TabPane>
      <TabPane label="智能运维" name="1"></TabPane>
      <TabPane label="常规运维" name="2"></TabPane>
    </Tabs> -->
    <div class="tips" style="margin-bottom: 20px">
      <Icon type="md-alert" size="20" color="#2d8cf0" style="margin-right: 10px" />
      <div>
        <div>
          1、创建设备前，首先要在以下板块创建一条有效数据：设备站点、维护人员(需激活)；
        </div>
        <div>2、设备档案创建后，设备端需要安装云知印软件并连接互联网后才能正常使用；</div>
        <div>
          3、新设备包含15天免费运营期，到期设备会自动停用，你可提前通过购买安全码或在线购买延续运营期的方式让设备继续运行；
        </div>
      </div>
    </div>
    <div class="filter-box" style="padding-top: 0; margin-bottom: 20px">
      <div style="display: flex">
        <Input v-model.trim="search.val2" placeholder="根据条件搜索" style="width: 316px">
          <Select v-model="search.select2" slot="prepend" style="width: 90px">
            <Option value="sn">序列号</Option>
            <Option value="mark">设备ID</Option>
            <Option value="charge_name">计费方案</Option>
          </Select>
        </Input>
        <Input
          v-model.trim="search.val4"
          placeholder="根据条件搜索"
          style="width: 316px; margin-left: 20px"
        >
          <Select v-model="search.select4" slot="prepend" style="width: 90px">
            <Option value="software_name">终端软件</Option>
            <Option value="software_version">软件版本</Option>
          </Select>
        </Input>
        <Input
          v-model.trim="search.val1"
          placeholder="根据条件搜索"
          style="width: 316px; margin-left: 20px"
        >
          <Select v-model="search.select1" slot="prepend" style="width: 90px">
            <Option value="site_name">设备站点</Option>
            <Option value="address">设备地址</Option>
            <Option value="scene_name">场景类型</Option>
          </Select>
        </Input>
      </div>
      <div style="margin-top: 10px; display: flex; align-items: center">
        <Input v-model.trim="search.val3" placeholder="根据条件搜索" style="width: 316px">
          <Select v-model="search.select3" slot="prepend" style="width: 90px">
            <Option value="repair_name">维护人员</Option>
            <Option value="agent_name">合作伙伴</Option>
          </Select>
        </Input>
        <span class="subtitle" style="margin-left: 20px">网络状态:</span>
        <Select
          v-model="search.network"
          style="width: 250px; margin-left: 6px"
          placeholder="选择网络状态"
        >
          <Option :value="-1">全部</Option>
          <Option :value="1">正常</Option>
          <Option :value="0">离线</Option>
        </Select>
      </div>

      <div class="bottom">
        <span class="btn-filter" @click="tableLoading ? null : searchOk()">筛选</span>
        <span class="btn" @click="reset">清空</span>

        <Poptip title="导出Excel" placement="right" trigger="hover">
          <span class="btn">导出报表</span>
          <div slot="content">
            <Button type="primary" style="margin-right: 5px" @click="exportData(0)"
              >导出当前页</Button
            >
            <Button type="success" @click="exportData(1)">导出所有页</Button>
          </div>
        </Poptip>
      </div>
    </div>

    <div class="bottom_left">
      <p class="tag_p">
        <span
          class="tag"
          @click="selectStatus(-1)"
          :class="{ active: page.status === -1 }"
          >全部</span
        >
        <span class="tag" @click="selectStatus(0)" :class="{ active: page.status === 0 }"
          >正常({{ normal }})</span
        >
        <span class="tag" @click="selectStatus(4)" :class="{ active: page.status === 4 }"
          >即将到期({{ soon }})</span
        >
        <span class="tag" @click="selectStatus(3)" :class="{ active: page.status === 3 }"
          >到期({{ overdue }})</span
        >
        <span class="tag" @click="selectStatus(1)" :class="{ active: page.status === 1 }"
          >停用</span
        >
        <span class="tag" @click="selectStatus(2)" :class="{ active: page.status === 2 }"
          >回收站</span
        >
      </p>
    </div>

    <div style="position: relative">
      <Table :columns="columns" :data="data" @on-sort-change="tableSort">
        <template slot-scope="{ row }" slot="remarks">
          <span class="remark_txt" @click="addRemark(row.id, row.remarks)">{{
            row.remarks ? row.remarks : "无"
          }}</span>
        </template>
      </Table>
      <div class="t-right">
        <Page
          @on-change="pageChange"
          @on-page-size-change="sizeChange"
          :current="page.p + 1"
          :total="total"
          show-elevator
          show-sizer
          show-total
        />
      </div>
      <Spin fix v-if="tableLoading">
        <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
        <div>加载中...</div>
      </Spin>
    </div>
    <Modal v-model="searchModal" title="高级搜索">
      <Row
        class="rowMargin"
        type="flex"
        justify="space-between"
        v-for="(item, index) in searchList"
        :key="index"
      >
        <Col :span="8">
          <Select v-model="item.cond">
            <Option v-for="(a, b) in searchItem" :value="a.cond" :key="b">{{
              a.title
            }}</Option>
          </Select>
        </Col>
        <Col :span="4">
          <Select v-model="item.type">
            <Option :value="0">等于</Option>
            <Option :value="1">包含</Option>
            <Option :value="2">不等于</Option>
          </Select>
        </Col>
        <Col :span="7">
          <div v-for="(a, b) in searchItem" :key="b">
            <div v-if="item.cond === a.cond && a.select">
              <Select v-model="item.value" placeholder="选择搜索值">
                <Option v-for="(s, si) in a.select" :key="si" :value="s.val">{{
                  s.title
                }}</Option>
              </Select>
            </div>
            <div v-if="item.cond === a.cond && !a.select">
              <Input v-model="item.value" placeholder="输入搜索值" />
            </div>
            <div v-if="!item.cond && b === 0">
              <Input v-model="item.value" placeholder="输入搜索值" />
            </div>
          </div>
        </Col>
        <Col :span="3" style="text-align: right">
          <Button type="error" @click="searchList.splice(index, 1)">删除</Button>
        </Col>
      </Row>
      <Button type="primary" @click="searchList.push({ type: 0 })" long
        >添加搜索条件</Button
      >
      <div slot="footer">
        <Button type="text" @click="searchModal = false">取消</Button>
        <Button type="primary" @click="searchOk">确定</Button>
      </div>
    </Modal>
    <Modal width="1050" v-model="info" title="设备信息">
      <p v-if="machine_info.create_time" style="padding-bottom: 10px">
        数据上报时间：{{ $moment(machine_info.create_time) }}
      </p>
      <div style="display: flex; justify-content: space-between">
        <Card style="width: 49.5%" title="碳粉状态">
          <Form label-position="left" :label-width="80">
            <FormItem
              v-for="(item, index) in machine_info.toner"
              :label="item.name"
              :key="index"
            >
              <Progress :stroke-width="15" status="active" :percent="item.val" />
            </FormItem>
            <div class="spin-center" v-if="!machine_info.toner">
              <Spin></Spin>
            </div>
          </Form>
        </Card>
        <Card style="width: 49.5%" title="纸盘状态">
          <Form label-position="left" :label-width="80">
            <FormItem
              v-for="(item, index) in machine_info.tray"
              :label="item.name"
              :key="index"
            >
              <Progress :stroke-width="15" status="active" :percent="item.val" />
            </FormItem>
            <div class="spin-center" v-if="!machine_info.tray">
              <Spin></Spin>
            </div>
          </Form>
        </Card>

        <Card style="width: 49.5%" title="异常信息">
          <Form label-position="left" :label-width="80">
            <!-- <p v-for="(item,index) in machine_info.abnormal">异常{{index + 1}}：{{item}}</p> -->
            <p
              v-for="(item, index) in machine_error"
              :key="index"
              v-if="item.log !== 'off_line'"
            >
              异常{{ index + 1 }}: {{ item.log }}
            </p>
          </Form>
        </Card>
      </div>
    </Modal>
    <Modal v-model="tipStatus" title="异常信息" footer-hide :width="600">
      <p style="font-size: 25px; color: #111">安全码核验未通过，请检查输入无误！</p>
      <p style="color: red; margin-top: 20px">
        (
        提示：由于安全码进行了技术升级，2022年1月1日之前采购的安全码，请联系“18623405855”进行更换新的安全码
        )
      </p>
      <div style="height: 120px; border-bottom: 1px solid #dcdee2"></div>
      <div class="zhidaole" @click="tipStatus = false">知道了</div>
    </Modal>
    <Modal v-model="expire.visible" title="设备运营期延续" footer-hide :width="600">
      <!-- @on-ok="editMachine" -->
      <div class="tips">
        <Icon
          type="md-alert"
          size="20"
          color="#2d8cf0"
          style="margin-right: 10px"
        />请确保需要延续运营期的设备序列号无误，错误操作将无法撤销
      </div>
      <div class="expire_box">
        <div class="title">设备序列号</div>
        <div class="sn">{{ pay_period.sn }}</div>
        <div v-if="!expire.isChangeDate">
          <Input
            v-model="expire.code"
            class="input"
            size="large"
            v-if="!expire.isGetOperate"
            placeholder="请输入云知印安全码License"
          />
          <div class="verify_box" v-if="expire.isGetOperate">
            <img
              v-if="expire.data.id"
              class="icon"
              src="../../../assets/images/ic_success.png"
            />
            <span v-if="expire.data.id"
              >核验通过，安全码所含运营期{{ expire.data.month }}个月</span
            >
            <span v-else style="color: #c00000">未找到匹配安全码，请核对后重新输入</span>
          </div>
          <div class="hint">
            安全码为16位数字+字母组合，输入时区分大小写，输入后点击核验
          </div>
        </div>
        <div v-else>
          <DatePicker
            :options="expire_date"
            v-model="expire.expire_time"
            type="date"
            size="large"
            placeholder="请选择授权截止日期"
            class="input"
          ></DatePicker>
          <div>
            <input class="remark" v-model="expire.note" placeholder="备注说明" />
          </div>
        </div>
        <div class="line"></div>
        <div v-if="!expire.isChangeDate">
          <div v-if="!expire.isGetOperate">
            <Button
              type="primary"
              class="btn_operate"
              @click="getOperate"
              :loading="expire.loading"
              >核验</Button
            >
            <!-- <div class="btn_operate" @click="getOperate">核验</div> -->
            <div v-if="expire.tp" class="change_expire_date" @click="changeExpireDate">
              直接授权运营期
            </div>
            <div
              v-if="!expire.tp && expire.meter == 1"
              class="change_expire_date"
              @click="$router.push({ name: 'increment' })"
            >
              购买智能运维安全码
            </div>
          </div>
          <div v-else class="bottom_box">
            <div v-if="expire.data.id">
              <Button class="btn_cancel" @click="expire.visible = false">取消</Button>
              <Button
                type="primary"
                class="btn_confirm"
                v-preventReClick
                :loading="expire.loading"
                @click="operateOk"
                >延续</Button
              >
            </div>
            <div v-else class="btn_operate" @click="reInput">重新输入</div>
          </div>
        </div>
        <div v-else class="bottom_box">
          <Button class="btn_cancel" @click="expire.isChangeDate = false">取消</Button>
          <Button
            type="primary"
            class="btn_confirm"
            @click="editMachine"
            v-preventReClick
            :loading="expire.loading"
            >延续</Button
          >
        </div>
      </div>
    </Modal>
    <Modal v-model="pay_period.visible" title="设备运营期延续" footer-hide :width="600">
      <div class="tips">
        <Icon
          type="md-alert"
          size="20"
          color="#2d8cf0"
          style="margin-right: 10px"
        />请确保需要延续运营期的设备序列号无误，错误操作将无法撤销
      </div>
      <div class="expire_box">
        <div class="title">设备序列号</div>
        <div class="sn">{{ pay_period.sn }}</div>
      </div>
      <div class="pay_content">
        <div class="pageTitle">
          选择延续时长
          <span class="tips2">(运营期可叠加购买)</span>
        </div>
        <RadioGroup
          v-model="pay_period.data.month"
          style="margin-top: 10px; padding-left: 10px; font-family: lucidasans"
          @on-change="changeMonth"
        >
          <Radio :label="12" style="margin-right: 122px"> 12月</Radio>
          <Radio :label="24" style="margin-right: 110px"> 24月(7.5折优惠)</Radio>
          <Radio :label="36">36月(6.6折优惠)</Radio>
        </RadioGroup>
        <div class="pageTitle" style="margin-top: 20px">支付方式</div>
        <RadioGroup
          v-model="pay_period.data.pay_type"
          style="margin-top: 10px; padding-left: 10px; display: flex"
        >
          <Radio :label="1" style="margin-right: 60px" class="radio">
            <img class="pay_icon" src="../../../assets/images/ic_pay2.png" />
          </Radio>
          <Radio :label="2" style="margin-right: 60px" class="radio">
            <img
              style="width: 26px"
              src="../../../assets/images/ic_alipay.png"
            />支付宝支付
          </Radio>
          <Radio :label="3" class="radio">
            <img class="pay_icon" src="../../../assets/images/ic_pay1.png" />
          </Radio>
        </RadioGroup>

        <div class="bankPayBox" v-if="pay_period.data.pay_type === 3">
          <!-- modal.data.pay_type -->
          <div class="item">
            <p class="tit">开户行：</p>
            <p class="txt">中国建设银行股份有限公司重庆九龙坡科园一路支行</p>
          </div>
          <div class="item">
            <p class="tit">对公账号：</p>
            <p class="txt">5005 0103 0049 0000 3745</p>
          </div>
          <div class="item">
            <p class="tit">开户名：</p>
            <p class="txt">九龙坡区云知印信息技术服务部</p>
          </div>
          <div class="item">
            <p class="tit">转账凭证：</p>
            <div class="voucher_uploadBox">
              <div class="upload" v-if="pay_period.data.filename.length < 3">
                <p class="t">
                  点击上传
                  <span style="color: #555; font-size: 10px">最多3张</span>
                </p>
                <input
                  type="file"
                  accept="image/png,image/jpeg,image/gif,image/jpg"
                  class="upBtn"
                  @change="chooseImage($event)"
                />
              </div>
              <div>
                <Tag
                  v-for="(item, index) in pay_period.data.filename"
                  :key="index"
                  closable
                  @on-close="deleteImage(index)"
                  >{{ item }}</Tag
                >
              </div>
            </div>
          </div>
        </div>
        <div class="line"></div>
        <div class="moneyBox">
          总计：<span style="font-size: 20px; color: #2d8cf0"
            ><span style="font-size: 14px">￥</span
            >{{ pay_period.data.operateMoney }}</span
          >
          <span v-if="pay_period.data.month >= 24">{{ pay_period.data.coupon }}</span>
        </div>
        <div class="subBtn" v-preventReClick @click="payPeriod">立即支付</div>
      </div>
    </Modal>

    <Modal
      v-model="payModalStatus"
      title="微信扫码支付"
      width="600"
      mask
      cancel-text=" "
      :footer-hide="true"
      style="text-align: center"
    >
      <canvas
        :style="{ height: '260px', width: '260px' }"
        :height="260"
        :width="260"
        ref="qr"
      ></canvas>
      <p style="text-align: center; line-height: 35px; margin-top: 20px">
        支付完成后请手动关闭此弹窗
      </p>
    </Modal>

    <Modal v-model="modalDispense.visible" title="设备分账设置" :width="700">
      <div class="tips">
        <Icon type="md-alert" size="20" color="#2d8cf0" style="margin-right: 10px" />
        设备与收款人关联后，即代表你同意将此设备的收益，按所设定的比例支付给此收款人；款项划拨后不可逆转，请谨慎操作！
      </div>
      <div class="dispense_box">
        <div>
          设备序列号：<span style="font-weight: bold">{{ modalDispense.sn }}</span>
        </div>
        <div style="margin-top: 26px">
          选择收款人：
          <Select
            v-model="modalDispense.data.accoun_id"
            class="select"
            style="width: 300px"
            placeholder="只能选择‘完成配置’的收款人"
          >
            <Option
              v-for="(item, index) in modalDispense.accounts"
              style="text-align: left"
              :key="index"
              :disabled="!item.user_id || item.status != 1 || item.is_del == 1"
              :value="item.id"
              >ID:{{ item.id }}&nbsp;&nbsp;{{ item.name
              }}{{
                item.is_del == 0
                  ? !item.user_id || item.status != 1
                    ? "(未配置)"
                    : ""
                  : "(已禁用)"
              }}</Option
            >
          </Select>

          <Button style="margin-left: 15px" v-preventReClick @click="addAccount"
            >确定</Button
          >
        </div>
        <div style="margin-top: 15px" v-if="modalDispense.dispense.length > 0">
          <table class="ivu-table ivu-table-default appoint-table">
            <tr>
              <th>收款ID</th>
              <th style="width: 150px">收款人</th>
              <th>分账比例</th>
              <th style="width: 130px; text-align: center">操作</th>
            </tr>
            <tr v-for="(item, index) in modalDispense.dispense" :key="index">
              <td>{{ item.dispense_account_id }}</td>
              <td style="width: 150px">
                {{ item.name }}
              </td>
              <td>
                <div style="display: flex; align-items: center">
                  <Input
                    placeholder="如分账比例是100%，则填入数字“100”"
                    v-model="item.extract"
                    :min="1"
                    :max="100"
                    maxlength="3"
                    type="number"
                    number
                  >
                  </Input>
                  <span>%</span>
                </div>
              </td>
              <td style="width: 130px; text-align: center">
                <span class="del" @click="remove(item, index)">删除</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button @click="modalDispense.visible = false">取消</Button>
        <Button @click="saveDisppence" v-preventReClick type="primary">确定</Button>
      </div>
    </Modal>

    <Modal v-model="machineConnect.status" title="连线记录" :width="400" footer-hide>
      <Table :columns="machineConnect.col" :data="machineConnect.data" />
    </Modal>

    <Modal
      v-model="modalPeriodLog.visible"
      title="运营期延续记录"
      :width="700"
      footer-hide
    >
      <div class="expire_box">
        <div class="title">设备序列号</div>
        <div class="sn">{{ modalPeriodLog.sn }}</div>
      </div>
      <Table
        :columns="modalPeriodLog.col"
        :data="modalPeriodLog.data"
        :height="400"
        style="margin: 20px 0"
      />
    </Modal>
    <Modal v-model="modalVerify.visible" title="负责人身份验证" :width="650" footer-hide>
      <div class="modal_verify">
        <div class="title">您正在进行敏感信息操作，为保证资金安全，请进行身份验证！</div>
        <div class="tip">
          {{
            modalVerify.isCode
              ? "验证码已发送至以下手机号，请注意查收"
              : "点击获取验证码，并正确填入"
          }}
        </div>
        <div class="tel">
          {{ modalVerify.tel }}
          <div class="getCode" v-if="!modalVerify.isCode" @click="getCode">
            获取验证码
          </div>
        </div>
        <div style="height: 130px; padding-top: 20px">
          <div class="input_box" v-if="modalVerify.isCode">
            <Input
              v-model="modalVerify.code"
              class="input"
              size="large"
              placeholder="请正确填入验证码"
            />
            <div class="confirm" @click="confirmVerify">
              确认
              <!-- ({{ verifiy.verifiyBtnText }}) -->
            </div>
          </div>
        </div>
      </div>
    </Modal>
    <Modal v-model="modalLog.visible" title="记录" width="1100" footer-hide>
      <Tabs v-model="tab_index" @on-click="tabClick">
        <TabPane label="跟进记录" name="tab1" v-if="!agent.tp">
          <div class="work_drawer_details">
            <div class="detail-info">
              <div class="parts-title">基本信息</div>
              <div class="info_box" style="padding-left: 10px">
                <Row>
                  <Col span="8"
                    ><span class="tit">设备站点：</span
                    ><span>{{ modalLog.data.site_name }}</span></Col
                  >
                  <Col span="8"
                    ><span class="tit">序列号：</span
                    ><span>{{ modalLog.data.sn }}</span></Col
                  >
                  <Col span="8"
                    ><span class="tit">终端软件：</span
                    ><span>{{ modalLog.data.software_name }}</span></Col
                  >
                </Row>
                <Row style="padding-top: 4px">
                  <Col span="8"
                    ><span class="tit">运营状态：</span
                    ><span>{{
                      operation_status[modalLog.data.status] +
                      `(${$moment(modalLog.data.expire_time, "YYYY-MM-DD")})`
                    }}</span></Col
                  >
                  <Col span="8"
                    ><span class="tit">维护人员：</span
                    ><span>{{
                      modalLog.data.repair_name + `(${modalLog.data.repair_tel})`
                    }}</span></Col
                  >
                  <Col span="8"
                    ><span class="tit">合作伙伴：</span
                    ><span>{{
                      modalLog.data.agent_name +
                      (modalLog.data.agent_service_tel
                        ? `(${modalLog.data.agent_service_tel})`
                        : "")
                    }}</span></Col
                  >
                </Row>
              </div>
              <div class="parts-title">沟通记录</div>
              <div class="record_list_box">
                <div
                  class="item-top"
                  :class="{ item: index > 0, right: item.type == 1 }"
                  v-for="(item, index) in modalLog.message"
                  :key="index"
                >
                  <div class="time">
                    <span style="color: #47a753; margin-right: 5px">●</span>
                    <span>{{ $moment(item.create_time) }}</span>

                    <span style="margin-left: 20px">{{ item.username }}</span>
                  </div>

                  <div class="content_b">
                    <div class="ds">
                      {{ item.content }}
                    </div>
                    <span class="f_item" v-for="(i, k) in item.enclosure" :key="k">
                      <a class="btn_look" target="_blank" :href="i.url"
                        >附件{{ k + 1 }}</a
                      >
                    </span>
                  </div>
                </div>
              </div>
              <div class="parts-title" style="margin-top: 45px">新建记录</div>
              <div class="message-box">
                <span style="color: #d40000">*</span>
                <span style="margin: 0 6px; color: #000">记录描述</span>
                <span style="color: #999">(必填项)</span>
                <div class="desc_input">
                  <Input
                    v-model="modalLog.subimtMessage.describe"
                    type="textarea"
                    :autosize="{ minRows: 5 }"
                    placeholder="此处限定5000字符"
                  />
                </div>
                <div class="subtitle">上传附件</div>
                <div>
                  <div class="up_box">
                    <Button icon="md-add">添加附件</Button>
                    <input type="file" class="file_input" @change="uploadChangeFile" />
                  </div>
                  <p class="filt-tag" v-for="(item, index) in files" :key="index">
                    <Tag closable @on-close="deleteFiles(index)"> {{ item }}</Tag>
                  </p>
                  <div class="description">
                    可上传<span style="color: #f2935e">5个附件</span
                    >每个附件大小不得超过8M。附件支持的格式有：'jpg','jpeg','bmp','png',<br />'gif','txt','rar','zip','doc','docx','ini','conf','eml','xlsx','xls','pdf',
                  </div>
                </div>
                <Button
                  type="primary"
                  class="submit"
                  v-preventReClick
                  :loading="modalLog.loading"
                  :disabled="modalLog.subimtMessage.describe ? false : true"
                  @click="subimtMessage"
                  >提交</Button
                >
              </div>
            </div>
          </div>
        </TabPane>
        <TabPane label="故障记录" name="tab2">
          <div>
            <Table :columns="error_columns" :data="error_data" :loading="tableLoad">
            </Table>
            <div class="t-right" style="margin-top: 15px">
              <Page
                @on-change="errorPageChange"
                @on-page-size-change="errorSizeChange"
                :total="error_total"
                :current="error_page.p + 1"
                show-elevator
                show-sizer
                show-total
              />
            </div>
          </div>
        </TabPane>
      </Tabs>
    </Modal>
    <machine-dispense
      v-model="machineDispenseParams.visible"
      :machine="machineDispenseParams.machine"
      @cancel="machineDispenseParams.visible = false"
    ></machine-dispense>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import excel from "@/libs/excel";
import devicesError from "@/config/device_error.js";
import OSS from "ali-oss";
import config from "@/config";
import machineDispense from "../machineDispense";
import qr from "qr.js";
export default {
  components: { machineDispense },
  data() {
    this.searchItem = [
      { cond: "id", title: "设备ID", width: 150 },
      { cond: "site_name", title: "站点" },
      { cond: "sn", title: "序列号" },
      {
        cond: "meter",
        title: "设备类型",
        select: [
          { title: "云印", val: 0 },
          { title: "云印+抄表", val: 1 },
          { title: "抄表", val: 2 },
          { title: "其他", val: -1 },
        ],
      },
      { cond: "software_name", title: "终端软件" },
      {
        cond: "machine_status",
        title: "网络状态",
        select: [
          { title: "连接", val: 1 },
          { title: "未连接", val: 0 },
        ],
      },
      {
        cond: "status",
        title: "运营状态",
        select: [
          { title: "正常", val: 0 },
          { title: "禁用", val: 1 },
          { title: "运营到期", val: 3 },
          { title: "运营即将到期", val: 4 },
        ],
      },
      { cond: "agent_name", title: "合作伙伴" },
      { cond: "company_name", title: "学校" },

      { cond: "address", title: "地址" },
      { cond: "support", title: "设备支持" },
      // {cond: "paper",title: "运营到期"},
      { cond: "charge_name", title: "计费方案" },
      { cond: "meter_charge_name", title: "抄表结算方案" },
      { cond: "repair_name", title: "维护人员" },
      { cond: "remarks", title: "备注" },
      { cond: "create_time", title: "创建时间" },
      { cond: "service_time", title: "最近在线时间" },
    ];
    return {
      syncStatus: false,
      tab_val: "0",
      tipStatus: false,
      machine_error: [],
      expire: {
        visible: false,
        id: "",
        sn: "",
        isChangeDate: false, //是否是修改运营期日期模式
        tp: false, //是否是运营商
        expire_time: "",
        expire_time_original: "",
        note: "",
        code: "",
        meter: 0,
        isGetOperate: false, //是否校验安全码
        loading: false,
        data: {},
      },
      expire_date: {
        disabledDate: (date) => {
          let disable = false;
          if (date && date.valueOf() < Date.now()) {
            disable = true;
          }
          if (date && date.valueOf() < new Date(this.expire.expire_time).getTime()) {
            disable = true;
          }
          return disable;
        },
      },
      payModalStatus: false,
      pay_period: {
        visible: false,
        sn: "",
        data: {
          machine_id: "", //设备ID
          type: 1,
          month: 12,
          pay_type: 1,
          eduction: 0,
          money: 0,
          oldMoney: 0,
          coupon: 0,
          file: [],
          filename: [],
          monthNumber: 0,
          operateMoney: 1200, //12个月1200
        },
      },
      modalDispense: {
        visible: false,
        sn: "",
        accounts: [],
        dispense: [],
        select: [],
        data: {
          id: "", //设备ID
          agent_id: "", //代理商ID
          accoun_id: "",
        },
      },
      modalPeriodLog: {
        visible: false,
        col: [
          {
            title: "操作日期",
            width: 140,
            key: "create_time",
            show: true,
            render: (h, data) => {
              return h("span", {}, this.$moment(data.row.create_time));
            },
          },
          {
            title: "操作方式",
            width: 100,
            key: "type",
            render: (h, data) => {
              return h(
                "span",
                {},
                data.row.type == 0
                  ? "在线购买"
                  : data.row.type == 1
                  ? "安全码核验"
                  : "直接授权"
              );
            },
          },
          {
            title: "延续至",
            width: 140,
            key: "time",
            render: (h, data) => {
              return h("span", {}, this.$moment(data.row.end_time, "YYYY-MM-DD"));
            },
          },
          {
            title: "备注说明",
            key: "note",
          },
        ],
        data: [],
      },
      modalVerify: {
        visible: false,
        isCode: false,
        tel: "",
        code: "",
        data: null,
      },
      info: false,
      page: {
        l: 10,
        p: 0,
        status: -1,
        cond: "sn",
        value: "",
        senior: "", //筛选参数
        key: "",
        order: "desc",
      },
      search: {
        type: 0,
        network: -1,
        device: -1,
        select1: "site_name",
        select2: "sn",
        select3: "repair_name",
        select4: "software_name",
        val1: "",
        val2: "",
        val3: "",
        val3: "",
      },
      tableLoading: false,
      searchList: [],
      // data: [],
      normal: 0,
      overdue: 0,
      soon: 0,
      total: 0,
      start: [
        {
          title: "设备ID",
          width: 150,
          fixed: "left",
          key: "mark",
        },
        {
          title: "站点",
          minWidth: 120,
          fixed: "left",
          key: "site_name",
          sortable: "custom",
          show: true,
          tooltip: true,
        },
      ],
      col: [
        {
          title: "序列号",
          width: 120,
          key: "sn",
          show: true,
        },

        {
          title: "终端软件",
          minWidth: 130,
          key: "software_name",
          sortable: "custom",
          show: true,
          render: (h, data) => {
            return h("span", {}, data.row.meter == 2 ? "-" : data.row.software_name);
          },
        },
        {
          title: "软件版本",
          minWidth: 100,
          key: "software_version",
          show: true,
          render: (h, data) => {
            return h(
              "span",
              {},
              data.row.software_version ? "V" + data.row.software_version : ""
            );
          },
        },
        {
          title: "网络状态",
          minWidth: 90,
          key: "machine_status",
          show: true,
          render: (h, data) => {
            console.log(
              "网络状态",
              data.row.sn,
              data.row.meter,
              data.row.status,
              data.row.machine_status
            );
            return h(
              "div",
              {
                props: {},
                on: {
                  click: () => {
                    if (data.row.brand === "爱普生" || data.row.brand === "佳能") {
                      this.$Message.error("该设备暂不支持该功能");
                      return;
                    }
                    this.showMachineConnect(data.row.id);
                  },
                },
              },
              [
                data.row.meter === 2
                  ? "-"
                  : h("Icon", {
                      props: {
                        type:
                          data.row.machine_status &&
                          data.row.status !== 2 &&
                          data.row.status !== 3
                            ? "ios-wifi"
                            : "ios-wifi-outline",
                      },
                      style: {
                        fontSize: "16px",
                        color:
                          data.row.machine_status &&
                          data.row.status !== 2 &&
                          data.row.status !== 3
                            ? "#19be6b"
                            : "#ed4014",
                      },
                    }),
              ]
            );
          },
        },

        // TODO 还需要修改数据库配合
        {
          title: "设备状态",
          minWidth: 90,
          key: "error",
          show: true,
          render: (h, data) => {
            if (data.row.meter === 2 || data.row.machine_type_name === 'Canon') {
              return h("span", {}, "-");
            }
            let expire_time = data.row.expire_time;
            let maintain_expire_time = data.row.maintain_expire_time;
            if (!(expire_time instanceof Date)) {
              expire_time = new Date(expire_time.replace(/-/g, "/"));
            }
            if (maintain_expire_time && !(maintain_expire_time instanceof Date)) {
              maintain_expire_time = new Date(maintain_expire_time.replace(/-/g, "/"));
            }
            if (
              !data.row.machine_status ||
              data.row.status === 2 ||
              data.row.status === 3
            ) {
              return "";
            }
            switch (data.row.meter) {
              case 0:
                if (expire_time && new Date() > expire_time) {
                  return "";
                }
                break;
              case 1:
                if (maintain_expire_time && new Date() > maintain_expire_time) {
                  return "";
                }
                break;
            }

            if (data.row.error == "") {
              return h(
                "div",
                {
                  props: {},
                  on: {
                    click: () => {
                      if (data.row.machine_status) {
                        // 获取单台设备数据
                        this.info = true;
                        if (data.row.brand === "爱普生" || data.row.brand === "佳能") {
                          this.GetMachineLastError({ id: data.row.id }).then((res) => {
                            if (!res.data.id) {
                              this.$Message.error("该设备不存在耗材数据");
                              this.info = false;
                            }
                          });
                        } else {
                          this.socketSend({
                            action: 10004,
                            value: { sn: data.row.sn, agent_id: this.agent.id },
                          });
                        }
                        this.machine_error = [];
                        this.MachineError({ id: data.row.id }).then((res) => {
                          console.log("res", res);
                          this.machine_error = res;
                        });
                      }
                    },
                  },
                },
                [
                  h("i", {
                    props: {
                      type: "iconzhengchang",
                      custom: "iconfonts",
                    },
                    style: {
                      fontSize: "16px",
                      color: "#ed4014",
                      marginRight: "5px",
                      background:
                        "url(" +
                        config.errorImageHost +
                        devicesError.success.icon +
                        ") 0% 0% / cover",
                      width: "15px",
                      height: "15px",
                      display: "inline-block",
                      backgroundSize: "cover",
                    },
                  }),
                ]
              );
            }
            let htm = [];
            if (data.row.error) {
              let error = data.row.error.split(",");
              for (let i = 0; i < error.length; i++) {
                if (devicesError[error[i]].text === "设备离线") {
                  continue;
                }
                htm.push(
                  h("i", {
                    props: {},
                    style: {
                      fontSize: "16px",
                      color: "#ed4014",
                      marginRight: "5px",
                      background:
                        "url(" +
                        config.errorImageHost +
                        devicesError[error[i]].icon +
                        ") 0% 0% / cover",
                      width: "15px",
                      height: "15px",
                      display: "inline-block",
                      backgroundSize: "cover",
                    },
                  })
                );
              }
            }

            return h(
              "div",
              {
                props: {},
                on: {
                  click: () => {
                    if (data.row.machine_status) {
                      // 获取单台设备数据
                      this.info = true;

                      if (data.row.brand == "爱普生" || data.row.brand == "佳能") {
                        this.GetMachineLastError({ id: data.row.id });
                      } else {
                        this.socketSend({
                          action: 10004,
                          value: { sn: data.row.sn, agent_id: this.agent.id },
                        });
                      }
                      this.machine_error = [];
                      this.MachineError({ id: data.row.id }).then((res) => {
                        this.machine_error = res;
                      });
                    }
                  },
                },
              },
              htm
            );
          },
        },
        {
          title: "运营状态",
          minWidth: 110,
          key: "status",
          show: true,
          render: (h, data) => {
            let status = {
              0: "正常",
              1: "禁用",
              2: "删除",
              3: "到期已停用",
              4: "即将到期",
            };
            return h(
              "span",
              {
                style: {
                  color: data.row.status == 0 ? "rgb(25, 190, 107)" : "red",
                  cursor: "pointer",
                },
                on: {
                  click: () => {
                    if (data.row.status == 3 || data.row.status == 4) {
                      this.countinueDate(data.row);
                    }
                  },
                },
              },
              data.row.meter === 2 ? "-" : status[data.row.status]
            );
          },
          renderHeader: (h, params) => {
            return h(
              "Tooltip",
              {
                props: { size: "small", placement: "bottom", transfer: true },
              },
              [
                h("span", [
                  h("span", "运营状态"),
                  h("Icon", {
                    props: { type: "md-alert", size: 14 },
                    style: {
                      marginLeft: "3px",
                    },
                  }),
                ]),
                h(
                  "span",
                  {
                    slot: "content",
                    style: {
                      whiteSpace: "normal",
                    },
                  },
                  "设备到期超6个月自动进入回收站，如需继续使用，请至回收站恢复"
                ),
              ]
            );
          },
        },
        {
          title: "运营到期",
          minWidth: 155,
          key: "expire_time",
          sortable: "custom",
          show: true,
          render: (h, data) => {
            if (data.row.meter === 2) {
              return h("span", {}, "-");
            }
            let expire_time = "";
            if (data.row.meter === 0 && data.row.expire_time) {
              expire_time = this.$moment(data.row.expire_time, "YYYY-MM-DD");
            } else if (data.row.meter === 1 && data.row.maintain_expire_time) {
              expire_time = this.$moment(data.row.maintain_expire_time, "YYYY-MM-DD");
            } else expire_time = this.$moment(data.row.trail_expire_time, "YYYY-MM-DD");
            /* if (data.row.expire_time) {
              expire_time = this.$moment(data.row.expire_time, "YYYY-MM-DD");
            } else if (data.row.trail_expire_time) {
              expire_time = this.$moment(data.row.trail_expire_time, "YYYY-MM-DD" );
            } else {
              expire_time = "-";
            } */
            return h(
              "div",
              {
                style: {
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                },
              },
              [
                h("div", { style: { marginRight: "5px" } }, expire_time),
                h(
                  "div",
                  {
                    style: { cursor: "pointer", color: "#2d8cf0" },
                    on: {
                      click: () => {
                        this.countinueDate(data.row);
                      },
                    },
                  },
                  "延续"
                ),
                h("img", {
                  attrs: {
                    src: require("../../../assets/images/ic_date_log.png"),
                  },
                  style: {
                    cursor: "pointer",
                    width: "15px",
                    height: "15px",
                    marginLeft: "5px",
                  },
                  on: {
                    click: () => {
                      this.modalPeriodLog.visible = true;
                      this.modalPeriodLog.sn = data.row.sn;
                      this.GetMachineRenew({ machine_id: data.row.id }).then((res) => {
                        this.modalPeriodLog.data = res.data;
                      });
                    },
                  },
                }),
              ]
            );
          },
        },
        {
          title: "设备型号",
          minWidth: 110,
          key: "machine_type_name",
          sortable: "custom",
          show: true,
        },
        /* {
          title: "设备类型",
          minWidth: 110,
          key: "meter",
          sortable: "custom",
          show: true,
          render: (h, data) => {
            switch (data.row.meter) {
              case 0:
                return h("span", {}, "云知印");
                break;
              case 1:
                return h("span", {}, "智能运维");
                break;
              case 2:
                return h("span", {}, "常规运维");
                break;
            }
          },
        },
        {
          title: "计费方案",
          minWidth: 120,
          key: "charge_name",
          sortable: "custom",
          show: true,
          render: (h, data) => {
            return h("span", {}, data.row.meter ? "-" : data.row.charge_name);
          },
        }, */
        {
          title: "维护人员",
          minWidth: 120,
          key: "repair_name",
          sortable: "custom",
          show: true,
          render: (h, data) => {
            // return h(
            //   "Button",
            //   {
            //     props: { type: "primary", size: "small" },
            //     style: { marginRight: "5px" },
            //     on: {
            //       click: () => {
            //         this.showMachineRepair(data.row.id)
            //       },
            //     },
            //   },
            //   "查看"
            // )
            return h(
              "div",
              {
                style: { cursor: "pointer", color: "#2d8cf0" },
                on: {
                  click: () => {
                    this.showMachineRepair(data.row.id);
                  },
                },
              },
              "查看"
            );
          },
        },
        {
          title: "地址",
          minWidth: 230,
          key: "address",
          sortable: "custom",
          show: true,
          tooltip: true,
          render: (h, data) => {
            return [
              // h("TextTooltip", {
              //   props: {
              //     val: `${data.row.province}-${data.row.city}-${data.row.area} ${
              //       data.row.address + data.row.address_detail
              //     }`,
              //     len: 16
              //   }
              // }),
              h(
                "span",
                {},
                data.row.province +
                  data.row.city +
                  (data.row.area ? data.row.area : "") +
                  (data.row.address ? data.row.address : "") +
                  data.row.address_detail
              ),
            ];
          },
        },
        {
          title: "屏保方案",
          minWidth: 100,
          key: "ad_name",
          show: 0,
          render: (h, data) => {
            return h("span", {}, data.row.meter === 2 ? "-" : data.row.ad_name);
          },
        },
        /* {
          title: "场景类型",
          minWidth: 100,
          key: "scene_name",
          show: 0,
          render: (h, data) => {
            return h("span", {}, data.row.meter ? "-" : data.row.scene_name);
          },
        }, */
        // {
        //   title: "所属",
        //   minWidth: 100,
        //   key: "tp",
        //   sortable: "custom",
        //   show: true,
        //   render: (h, data) => {
        //     return h("span", {}, data.tp ? "代理商" : "运营商");
        //   },
        // },
        {
          title: "合作伙伴",
          minWidth: 120,
          key: "agent_name",
          sortable: "custom",
          show: true,
        },
        {
          title: "学校",
          minWidth: 120,
          key: "company_name",
          sortable: "custom",
          show: true,
          render: (h, data) => {
            return h(
              "span",
              {},
              data.row.company_name
                ? data.row.company_name
                : `${data.row.tp ? "代理商" : "运营商"}自营`
            );
          },
        },

        // {
        //   title: "设备支持",
        //   minWidth: 130,
        //   key: "support",
        //   sortable: "custom",
        //   show: true,
        //   tooltip: true,
        //   render: (h, data) => {
        //     return h("span", {}, data.row.meter ? "-" : data.row.support);
        //   },
        // },

        /* {
          title: "营业时间",
          minWidth: 105,
          key: "service_mon",
          show: true,
          render: (h, data) => {
            if (data.row.meter) {
              return h("span", {}, "-");
            }
            return h(
              "Tooltip",
              {
                props: { placement: "left" },
              },
              [
                h(
                  "span",
                  { style: { color: "#2db7f5", cursor: "pointer" } },
                  data.row.service_mon
                ),
                h("div", { slot: "content" }, [
                  h("p", {}, `周一: ${data.row.service_mon}`),
                  h("p", {}, `周二: ${data.row.service_tues}`),
                  h("p", {}, `周三: ${data.row.service_wed}`),
                  h("p", {}, `周四: ${data.row.service_thur}`),
                  h("p", {}, `周五: ${data.row.service_fri}`),
                  h("p", {}, `周六: ${data.row.service_sat}`),
                  h("p", {}, `周日: ${data.row.service_sun}`),
                ]),
              ]
            );
          },
        }, */
        /* {
          title: "抄表结算方案",
          minWidth: 130,
          key: "meter_charge_name",
          sortable: "custom",
          show: true,
          render: (h, data) => {
            return h("span", {});
          },
        }, */
        {
          title: "备注",
          minWidth: 200,
          key: "remarks",
          slot: "remarks",
          show: true,
        },
        {
          title: "创建时间",
          minWidth: 135,
          key: "create_time",
          sortable: "custom",
          show: true,
          render: (h, data) => {
            return h("span", {}, this.$moment(data.row.create_time));
          },
        },
        {
          title: "最近在线时间",
          minWidth: 135,
          key: "service_time",
          show: true,
          render: (h, data) => {
            if (data.row.meter === 2) {
              return h("span", {}, "-");
            }
            return h(
              "span",
              {},
              data.row.machine_status
                ? this.$moment()
                : data.row.service_time
                ? this.$moment(data.row.service_time)
                : ""
            );
          },
        },
      ],
      end: [
        {
          title: "操作",
          width: 200,
          key: "operator",
          fixed: "right",
          render: (h, data) => {
            let temp = [];
            /* if (!data.row.meter) {
              temp.push(
                h(
                  "Button",
                  {
                    props: { type: "warning", size: "small" },
                    style: { marginRight: "5px" },
                    on: {
                      click: () => {
                        console.log("agent", this.agent);
                        this.shopModalDispense(data.row);
                        return false;

                        //判断分账验证是否失效
                        if (this.cacheGet("dispense_verify")) {
                          this.shopModalDispense(data.row);
                        } else {
                          this.modalVerify.visible = true;
                          this.modalVerify.tel =
                            this.agent.leader_tel.substr(0, 3) +
                            "****" +
                            this.agent.leader_tel.substr(7);
                          this.modalVerify.data = data.row;
                        }
                      }
                    }
                  },
                  "分账"
                )
              );
            } */
            temp.push(
              h(
                "Button",
                {
                  props: { type: "warning", size: "small" },
                  style: { marginRight: "5px" },
                  on: {
                    click: () => {
                      console.log("筛选", this.search);
                      let search = JSON.stringify(this.search);
                      localStorage.setItem("machine_list", search);
                      this.$router.push({
                        name: "machine-edit",
                        params: { id: data.row.id },
                      });
                    },
                  },
                },
                "编辑"
              )
            );
            temp.push(
              h(
                "Button",
                {
                  props: { type: "warning", size: "small" },
                  on: {
                    click: () => {
                      this.modalLog.visible = true;
                      this.modalLog.data = data.row;
                      let myDate = new Date();
                      myDate.setFullYear(myDate.getFullYear() - 1);
                      this.error_page = {
                        p: 0,
                        l: 10,
                        status: -1,
                        type: -1,
                        sn: data.row.sn,
                        andData: { sn: data.row.sn },
                        start: this.$moment(myDate, "YYYY-MM-DD"), //最近一年的故障记录
                        end: this.$moment(new Date(), "YYYY-MM-DD"),
                      };
                      if (!this.agent.tp) {
                        this.tab_index = "tab1";
                        //获取沟通记录
                        this.GetMachineTrack({ machine_id: data.row.id }).then((res) => {
                          res.data.map((item) => {
                            item.enclosure = JSON.parse(item.enclosure);
                          });
                          this.modalLog.message = res.data;
                        });
                      } else {
                        this.tab_index = "tab2";
                        this.getErrorList();
                      }
                    },
                  },
                },
                "记录"
              )
            );
            return h("div", { style: "width: 200px" }, temp);
          },
        },
      ],
      columns: [],
      searchModal: false,
      searchShow: [],
      machineConnect: {
        data: [],
        col: [
          {
            title: "设备主动请求连接服务器记录",
            minWidth: 135,
            key: "create_time",
            show: true,
            render: (h, data) => {
              return h("span", {}, this.$moment(data.row.create_time));
            },
          },
        ],
        status: false,
      },
      verifiy: {
        verifiyBtnText: "获取验证码",
        verifiyTime: 0,
        timer: null,
      },
      tab_index: "tab1",
      error_data: [],
      error_columns: [
        {
          title: "发生时间",
          key: "create_time",
          render: (h, data) => {
            return h("span", this.$moment(new Date(data.row.create_time)));
          },
          width: 200,
          search: true,
        },
        {
          title: "故障描述",
          key: "log",
          search: true,
        },
        {
          title: "记录状态",
          key: "status",
          render: (h, data) => {
            switch (data.row.status) {
              case 0:
                return h("div", {}, [
                  h(
                    "Button",
                    {
                      props: {
                        size: "small",
                        type: "error",
                      },
                    },
                    "未处理"
                  ),
                ]);
                break;
              case 1:
                return h("div", {}, [
                  h(
                    "Button",
                    {
                      props: {
                        size: "small",
                        type: "success",
                      },
                    },
                    "已处理"
                  ),
                ]);
                break;
            }
          },
          width: 150,
          search: true,
          searchOption: {
            type: "select",
            vals: [
              { name: "未处理", val: 0 },
              { name: "已处理", val: 1 },
            ],
          },
        },
        {
          title: "恢复时间",
          key: "result_time",
          search: true,
          render: (h, data) => {
            if (data.row.status === 0) {
              return h("span", "-");
            } else return h("span", this.$moment(new Date(data.row.result_time)));
          },
          width: 200,
        },
      ],
      files: [],
      modalLog: {
        visible: false,
        loading: false,
        data: {},
        message: [],
        subimtMessage: {
          describe: "",
          files: [],
        },
      },
      operation_status: {
        0: "正常",
        1: "禁用",
        2: "删除",
        3: "到期",
        4: "即将到期",
      },
      tableLoad: false,
      error_page: {
        p: 0,
        l: 10,
        sn: "",
        status: -1,
        type: -1,
        andData: {},
      },
      error_total: 0,
      machineDispenseParams: {
        visible: false,
        machine: {},
      },
    };
  },
  methods: {
    // 根据安全码延续运营期
    operateOk() {
      this.expire.loading = true;
      if (this.expire.data.id) {
        this.ActivateCode({
          id: this.expire.id,
          data: this.expire.data,
        })
          .then((res) => {
            this.expire.loading = false;
            if (res.status) {
              this.expire.visible = false;
              this.expire.isGetOperate = false;
              this.$Message.success(res.msg);
              this.getData();
            } else {
              this.$Message.error(res.msg);
            }
          })
          .catch(() => {
            this.$Message.error("系统异常");
          });
      } else {
        this.expire.loading = false;
        this.$Message.error("未检索到安全码，请尝试重新点击查询按钮");
      }
    },
    // 获取安全码代表的运营期
    getOperate() {
      this.expire.loading = true;
      this.GetOperateCode({ code: this.expire.code }).then((res) => {
        this.expire.loading = false;
        if (res.status) {
          this.expire.isGetOperate = true;
          this.expire.data = res.data;
        } else {
          this.tipStatus = true;
          // this.$Message.error(res.log);
        }
      });
    },
    // 表格排序
    tableSort(col) {
      this.page.key = col.key;
      this.page.order = col.order;
      this.getData();
    },
    // 导出Excel
    exportData(is_all) {
      let title = ["编号", "站点"],
        key = ["id", "site_name"];
      this.col.map((item) => {
        if (item.show) {
          title.push(item.title);
          key.push(item.key);
        }
      });
      let params = {
        title: title,
        key: key,
        autoWidth: true,
        filename: "设备列表",
      };
      if (is_all) {
        let page = JSON.parse(JSON.stringify(this.page));
        page.l = this.total;
        page.p = 0;
        this.tableLoading = true;
        this.getMachine(page).then((res) => {
          this.tableLoading = false;
          params.data = this.excelData(res.data);
          excel.export_array_to_excel(params);
        });
      } else {
        params.data = this.excelData(this.data);
        excel.export_array_to_excel(params);
      }
    },
    // 导出格式化数据
    excelData(data) {
      let result = JSON.parse(JSON.stringify(data));
      result.map((item) => {
        switch (item.meter) {
          case -1:
            item.meter = "其他";
            break;
          case 0:
            item.meter = "云印";
            break;
          case 1:
            item.meter = "云印+抄表";
            break;
          case 2:
            item.meter = "抄表";
            break;
        }
        let status = {
          0: "正常",
          1: "禁用",
          2: "删除",
          3: "到期",
          4: "即将到期",
        };
        item.machine_status = `${item.machine_status ? "连接" : "未连接"}`;
        item.tp = item.tp ? "代理商" : "运营商";
        item.status = status[item.status];
        item.address = item.address + item.address_detail;
        item.company_name = item.company_name ? item.company_name : `合作伙伴自营`;
        item.create_time = this.$moment(item.create_time);
        item.expire_time = this.$moment(
          item.expire_time || item.trail_expire_time,
          "YYYY-MM-DD"
        );
        item.service_time = item.service_time ? this.$moment(item.service_time) : "";
        item.address = `${item.province}-${item.city}-${item.area} ${item.address} ${item.address_detail}`;
      });
      console.log(275, result);
      return result;
    },
    typeClick() {
      this.search = {
        type: parseInt(this.tab_val),
        network: -1,
        device: -1,
        select1: "site_name",
        select2: "sn",
        select3: "repair_name",
        select4: "software_name",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
      };
      this.page.p = 0;
      this.page.senior = "";
      this.searchOk();
    },
    //筛选
    searchOk() {
      this.page.senior = "";
      this.searchShow = [];
      let temp = [];
      let search = this.search;
      console.log("筛选条件", search);
      if (search.type >= 0) {
        temp.push(`meter***0***${search.type}`);
      }
      if (search.network >= 0) {
        temp.push(`machine_status***0***${search.network}`);
      }
      if (search.device >= 0) {
        temp.push(`error***0***${search.device == 0 ? "" : "NULL"}`);
      }
      if (search.val1) {
        temp.push(`${search.select1}***1***${search.val1}`);
      }
      if (search.val2) {
        temp.push(`${search.select2}***1***${search.val2}`);
      }
      if (search.val3) {
        temp.push(`${search.select3}***1***${search.val3}`);
      }
      if (search.val4) {
        temp.push(`${search.select4}***1***${search.val4}`);
      }

      if (temp.length > 0) {
        this.page.senior = temp.join("|||");
      }
      this.page.p = 0;
      this.page.meter = this.search.type;
      this.getData();
    },
    // 重置获取数据
    reset() {
      this.search = {
        type: 0,
        network: -1,
        device: -1,
        select1: "site_name",
        select2: "sn",
        select3: "repair_name",
        select4: "software_name",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
      };
      this.page.p = 0;
      this.page.senior = "";
      this.tab_val = "0";
      localStorage.removeItem("machine_list");
      this.searchOk();
    },
    sizeChange(l) {
      this.page.l = l;
      this.getData();
    },
    pageChange(p) {
      this.page.p = p - 1;
      this.getData();
    },
    selectStatus(status) {
      this.page.status = status;
      this.getData();
    },
    getData() {
      this.tableLoading = true;
      this.getMachine(this.page).then((res) => {
        // this.data = res.data;
        this.total = res.total;
        this.normal = res.normal;
        this.soon = res.soon;
        this.overdue = res.overdue;
        this.tableLoading = false;
        let sns = [];
        res.data.map((item) => {
          // sns.push(item.sn);
          item.error = item.error ? item.error.replace(/off_line/g, "") : "";
          if (item.brand !== "爱普生" && item.brand !== "佳能") {
            item.machine_status = 0;
            this.socketSend({ action: 10009, value: { sn: item.sn } });
          }
        });
        if (sns.length) {
          // 获取当页设备连接状态
          // this.socketSend({ action: 10002, value: { sns: sns } });
        }
      });
    },
    editMachine() {
      this.expire.loading = true;
      this.expire.expire_time = this.$moment(this.expire.expire_time, "YYYY-MM-DD");
      if (this.expire.expire_time === this.expire.expire_time_original) {
        this.$Message.error("不能选择当前运营到期时间");
        return;
      }

      let data = { machine_id: this.expire.id };
      data.expire_time = this.expire.expire_time;
      data.note = this.expire.note;
      this.SetMachineDate(data).then((res) => {
        this.expire.loading = false;
        if (res.status) {
          this.expire.visible = false;
          this.expire.isChangeDate = false;

          this.getData();
          this.$Message.success("操作成功");
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    formatCol() {
      let temp = [];
      this.col.map((item) => {
        if (item.show === true) {
          temp.push(item);
        } else if (item.show === this.agent.tp) {
          temp.push(item);
        }
      });
      this.columns = this.start.concat(temp).concat(this.end);
    },
    showMachineConnect(machine_id) {
      this.GetMachineConnect({ machine_id }).then((res) => {
        this.machineConnect.status = true;
        this.machineConnect.data = res.data;
      });
    },
    changeExpireDate() {
      this.expire.isChangeDate = true;
    },
    reInput() {
      this.expire.isGetOperate = false;
      this.expire.code = "";
    },
    //选择延期月份
    changeMonth() {
      let month = this.pay_period.data.month;
      switch (month) {
        case 12:
          this.pay_period.data.operateMoney = 1200;
          this.pay_period.data.coupon = "";
          this.pay_period.data.type = 1;
          break;
        case 24:
          this.pay_period.data.operateMoney = 1800;
          this.pay_period.data.coupon = "(省 : 600.00元)";
          this.pay_period.data.type = 2;
          break;
        case 36:
          this.pay_period.data.operateMoney = 2400;
          this.pay_period.data.coupon = "(省 : 1200.00元)";
          this.pay_period.data.type = 3;
          break;
      }
    },
    //获取支付参数
    payPeriod() {
      let data = {
        types: [],
        money: 0,
        pay_type: this.pay_period.data.pay_type,
        machine_id: [],
      };
      let payData = this.pay_period.data;
      data.types.push(payData.type);
      data.money = payData.operateMoney;
      data.machine_id.push(parseInt(payData.machine_id));
      if (data.money > 0) {
        // let data = JSON.parse(JSON.stringify(data));
        data.agent_id = this.agent.id;
        if (data.pay_type !== 3) {
          this.BuyIncrement(data).then((res) => {
            if (res.code && res.code === 2) {
              this.$Message.error(res.msg);
              return false;
            }
            if (data.pay_type === 1) {
              //微信支付
              this.payModalStatus = true;
              this.showQrModal(res.code_url);
            } else if (data.pay_type === 2) {
              //支付宝
              window.open(`https://openapi.alipay.com/gateway.do?${res}`);
            }
          });
        } else {
          //银行转账
          try {
            if (data.pay_type === 3) {
              let formData = new FormData();
              if (payData.file.length > 0) {
                payData.file.map((item) => {
                  formData.append("file", item);
                });
                console.log("支付", formData);
                let ndata = data;
                this.TransferIncrement({
                  file: formData,
                  data: ndata,
                }).then((res) => {
                  console.log("結果", res);
                  this.pay_period.visible = false;
                  if (res) {
                    this.$Message.success("提交成功请等待审核!");
                  }
                });
              } else {
                this.$Message.error("请上传转账凭证");
              }
            } else {
            }
            this.visible = false;
          } catch (error) {}
        }
      }
    },
    //生成微信支付二维码
    showQrModal(data, name = "qr") {
      try {
        var $qr = this.$refs[name];
        var qrcode = qr(data);
        var ctx = $qr.getContext("2d");
        var cells = qrcode.modules;
        var tileW = 260 / cells.length;
        var tileH = 260 / cells.length;
        var scale = (window.devicePixelRatio || 1) / this.getBackingStorePixelRatio(ctx);
        $qr.height = $qr.width = 260 * scale;
        ctx.scale(scale, scale);
        cells.forEach((row, rdx) => {
          row.forEach((cell, cdx) => {
            ctx.fillStyle = cell ? "#000000" : "#FFFFFF";
            var w = Math.ceil((cdx + 1) * tileW) - Math.floor(cdx * tileW);
            var h = Math.ceil((rdx + 1) * tileH) - Math.floor(rdx * tileH);
            ctx.fillRect(Math.round(cdx * tileW), Math.round(rdx * tileH), w, h);
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    getBackingStorePixelRatio(ctx) {
      return (
        ctx.webkitBackingStorePixelRatio ||
        ctx.mozBackingStorePixelRatio ||
        ctx.msBackingStorePixelRatio ||
        ctx.oBackingStorePixelRatio ||
        ctx.backingStorePixelRatio ||
        1
      );
    },
    chooseImage(e) {
      this.pay_period.data.file.push(e.target.files[0]);
      this.pay_period.data.filename.push(e.target.files[0].name);
    },
    deleteImage(index) {
      this.pay_period.data.file.splice(index, 1);
      this.pay_period.data.filename.splice(index, 1);
    },
    //显示分账设置
    shopModalDispense(item) {
      // if (item.settle_type === 1) {
      //   this.machineDispenseParams.machine = item;
      //   this.machineDispenseParams.visible = true;
      //   return false;
      // }

      this.modalDispense.data.id = item.id;
      this.modalDispense.data.agent_id = item.agent_id;
      this.modalDispense.sn = item.sn;
      const that = this;
      this.GetPayee({ l: 1000, agent_id: item.agent_id }).then((res) => {
        that.modalDispense.accounts = res.data;
        that.GetUserAgentDispense({ id: item.id }).then((res) => {
          that.modalDispense.dispense = res;
          that.modalDispense.visible = true;
          that.modalDispense.select = JSON.parse(JSON.stringify(res));
        });
      });
    },
    //添加分账收款人
    addAccount() {
      if (!this.modalDispense.data.accoun_id) {
        this.$Message.error("请选择收款人");
        return;
      }
      if (this.modalDispense.select.length == 5) {
        this.$Message.error("一个设备最多绑定5个收款人!");
        return;
      }

      let id = this.modalDispense.data.accoun_id;
      let data = {},
        flag = true;
      this.modalDispense.accounts.map((item) => {
        if (item.id === id) {
          data = item;
        }
      });
      console.log("收款人信息", data);
      if ((data.pay_uid || data.user_id) && data.is_del === 0) {
        this.modalDispense.dispense.map((item) => {
          if (item.dispense_account_id === id) {
            flag = false;
          }
        });
        if (flag) {
          let item = {
            name: data.name,
            machine_id: this.modalDispense.data.id,
            dispense_account_id: id,
            extract: "",
          };
          this.modalDispense.dispense.push(item);
          this.modalDispense.select.push(item);
          // this.modalDispense.data.accoun_id = "";
        } else {
          this.$Message.error("该收款账号已存在");
        }
      } else {
        this.$Message.error("该收款账号未绑定收款方式");
      }
    },
    remove(data, index) {
      this.modalDispense.dispense.splice(index, 1);
      if (data.id) {
        // this.modalDispense.select[index].is_del = 1;
        this.modalDispense.select.map((item) => {
          if (item.id == data.id) item.is_del = 1;
        });
      }
      console.log("this.modalDispense.select", {
        ...this.modalDispense.select[index],
      });
    },
    //保存分账设置
    saveDisppence() {
      try {
        let total = 0,
          dels = [],
          insert = [],
          update = [],
          count = 0;
        this.modalDispense.dispense.map((item) => {
          this.modalDispense.select.map((i) => {
            if (item.dispense_account_id == i.dispense_account_id) {
              i.extract = item.extract;
            }
          });
        });
        let status = true;
        console.log("this.modalDispense", this.modalDispense);
        this.modalDispense.select.map((item) => {
          if (!item.is_del) {
            total += parseInt(item.extract);
            count++;
            if (
              (!parseInt(item.extract) ||
                parseInt(item.extract) < 1 ||
                parseInt(item.extract) > 100) &&
              status
            ) {
              this.$Message.error("保存失败,比例必须在1-100之间");
              status = false;
            }
          }
          if (item.id && item.is_del === 1) {
            dels.push(item.id);
          } else if (item.id) {
            update.push(item);
          } else {
            // delete item.name;
            insert.push(item);
          }
        });
        if (!status && (insert.length || update.length)) return false;
        // insert.map(item=>{delete item.name})

        console.log("并列", insert, update, dels);

        if (count === 0) {
        } else if (total !== 100 && this.agent.tp === 1) {
          this.$Message.error("保存失败,比例总和必须为100");
          return;
        } else if (
          total > 100 &&
          this.agent.tp === 0 &&
          this.agent.id === this.modalDispense.data.agent_id
        ) {
          this.$Message.error("保存失败,比例总和不能超过100");
          return;
        } else if (
          total !== 100 &&
          this.agent.tp === 0 &&
          this.agent.id !== this.modalDispense.data.agent_id
        ) {
          this.$Message.error("保存失败,比例总和必须为100");
          return;
        }
        this.SaveUserAgentDispense({
          machine_id: this.modalDispense.data.id,
          insert: insert,
          update: update,
          dels: dels,
        }).then((res) => {
          if (res.status) {
            this.$Message.success(res.msg);
            this.modalDispense.visible = false;
          } else {
            this.$Message.warning(res.msg);
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    //新增设备
    async addMachine() {
      this.$router.push({ name: "machine-add" });
      return;
      try {
        const [siteRes, chargeRes, repairRes] = await Promise.all([
          this.getSite(),
          this.getCharge(),
          this.getRepair(),
        ]);
        const siteTotal = siteRes.total;
        const chargeTotal = chargeRes.total;
        const repairTotal = repairRes.total;
        const isRrepair = repairRes.data.some((item) => item.gzh_openid); //已激活的维护人员

        console.log("判断", siteTotal, chargeTotal, repairTotal);
        if (siteTotal > 0 && chargeTotal > 0 && repairTotal > 0 && isRrepair) {
          //“计费方案”、 “设备站点”、“维护人员”、”收款人“ 都必须有一条数据
          this.$router.push({ name: "machine-add" });
        } else {
          this.$Modal.warning({
            title: "重要提示",
            content:
              "新增设备前，请在“计费方案”、 “设备站点”、“维护人员”增加一条可用数据（维护人员需激活，收款人需完成收款配置）",
            okText: "知道了",
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    getCode() {
      if (this.agent.leader_tel) {
        if (this.verifiy.time) return false;
        this.SendTelCode({ tel: this.agent.leader_tel, type: 2 }).then((res) => {
          this.$Message[res.status ? "success" : "error"](res.msg);
          if (res.status) {
            this.modalVerify.isCode = true;

            this.verifiy.time = 60;
            this.verifiy.timer = setInterval(() => {
              if (this.verifiy.time) {
                this.verifiy.time--;
                this.verifiy.verifiyBtnText = `${this.verifiy.time}S`;
              } else {
                this.verifiy.time = 0;
                this.verifiy.verifiyBtnText = "";
                clearInterval(this.verifiy.timer);
              }
            }, 1000);
          }
        });
      } else {
        this.$Message.error("请绑定负责人手机号！");
      }
    },
    confirmVerify() {
      if (this.modalVerify.code && this.modalVerify.code.length === 6) {
        this.CodeCheck({
          agent_id: this.agent.id,
          tel: this.agent.leader_tel,
          code: this.modalVerify.code,
        }).then((res) => {
          if (res.status) {
            //验证通过
            //设置验证失效时间(10分钟)
            this.cacheSet("dispense_verify", "true", 1440 * 60);

            this.shopModalDispense(this.modalVerify.data);
            this.modalVerify.isNext = true;
            this.modalVerify.code = "";
            this.modalVerify.visible = false;
            //取消倒计时
            this.verifiy.time = 0;

            this.verifiy.verifiyBtnText = `获取验证码`;
            clearInterval(this.verifiy.timer);
          } else {
            this.$Message["error"](res.msg);
          }
        });
      } else {
        this.$Message.error("请正确填入验证码");
      }
    },
    cacheSet(key, value = "", expire = 0) {
      console.log(key, value, expire);
      // 当前时间戳
      let nowTime = Math.ceil(Date.now() / 1000);
      // 设置数据
      localStorage.setItem(key, JSON.stringify(value));
      // 判断是否有过期时间
      if (expire > 0) {
        // 设置过期时间
        localStorage.setItem(key + "_expire", nowTime + parseInt(expire));
      } else {
        // 设置过期时间
        localStorage.setItem(key + "_expire", 0);
      }
      return true;
    },
    /**
     * 读取 localStoryage
     * @param key
     * @return bool|originData false|originData
     */
    cacheGet(key) {
      // 当前时间戳
      let nowTime = Math.ceil(Date.now() / 1000);
      // 获取键时间戳
      let rawCacheDataExpire = localStorage.getItem(key + "_expire");
      console.log("rawCacheDataExpire", key + "_expire", rawCacheDataExpire);
      let cacheDataExpire = parseInt(rawCacheDataExpire);
      console.log("cacheDataExpire", cacheDataExpire);

      // 强制过期时间 为0时忽略 用于解决缓存时间与本地时间差距过大(例本地更改了计算机时间)
      // 判断用户是否删除了过期时间 判断是否设置了过期时间 判断是否超过过期时间 判断当前计算机时间与设置的过期时间差距是否过大
      if (
        rawCacheDataExpire === null ||
        (cacheDataExpire > 0 && nowTime > cacheDataExpire)
      ) {
        console.log("删除过期key");
        // 删除过期key
        localStorage.removeItem(key);
        // 删除过期时间
        localStorage.removeItem(key + "_expire");
        return false;
      }
      // 获取数据
      let cacheData = JSON.parse(localStorage.getItem(key));

      if (cacheData === null || cacheData === false) {
        return false;
      }
      // 返回数据
      return cacheData;
    },
    deleteFiles(index) {
      this.files.splice(index, 1);
      this.modalLog.subimtMessage.files.splice(index, 1);
    },
    uploadChangeFile(e) {
      console.log("上传的文件", e);
      let file = e.target.files[0];
      if (file.size > 5242880) {
        this.$Notice.warning({
          title: "上传失败",
          desc: `文件”${file.name}“过大`,
        });
        return false;
      }
      this.$Spin.show();
      let date = this.$moment(new Date(), "YYYY-MM-DD");
      const OssClient = new OSS({
        region: config.oss.region,
        endpoint: config.oss.region,
        accessKeyId: config.oss.accessKeyId,
        accessKeySecret: config.oss.secretAccessKey,
        bucket: config.oss.bucket,
      });
      OssClient.put("machine/log/" + date + "/" + file.name, file)
        .then((res) => {
          this.$Spin.hide();
          let url = {
            name: file.name,
            url: res.url,
          };
          this.modalLog.subimtMessage.files.push(url);
          this.files.push(file.name);
        })
        .catch((err) => {
          console.log(err);
          this.$Message.error("error");
        });
    },
    subimtMessage() {
      console.log("点击了");
      let data = {
        machine_id: this.modalLog.data.id,
        content: this.modalLog.subimtMessage.describe,
        enclosure: JSON.stringify(this.modalLog.subimtMessage.files),
      };
      this.modalLog.loading = true;
      this.SaveMachineTrack(data).then((res) => {
        this.modalLog.loading = false;
        if (res.status) {
          this.modalLog = {
            visible: false,
            loading: false,
            data: {},
            message: [],
            subimtMessage: {
              describe: "",
              files: [],
            },
          };
          this.files = [];
        } else {
          this.$Message.error("error");
        }
      });
    },
    getErrorList() {
      this.tableLoad = true;
      this.MachineErrorList(this.error_page).then((res) => {
        this.error_data = res.data;
        this.error_total = res.total;
        this.tableLoad = false;
      });
    },
    errorSizeChange(l) {
      this.error_page.l = l;
      this.getErrorList();
    },
    errorPageChange(p) {
      this.error_page.p = p - 1;
      this.getErrorList();
    },
    tabClick(name) {
      if (name == "tab2") {
        this.getErrorList();
      }
    },
    addRemark(id, val) {
      let remark = val;
      this.$Modal.confirm({
        onOk: () => {
          let data = {
            id: id,
            remarks: remark,
          };
          this.saveMachine(data).then((res) => {
            if (res.status) {
              this.$Message.success("操作成功");
              this.getData();
            } else {
              this.$Message.error("操作失败");
            }
          });
        },
        render: (h) => {
          return h("Input", {
            props: {
              value: remark,
              autofocus: true,
              type: "textarea",
              placeholder: "输入备注信息",
            },
            on: {
              input: (val) => {
                remark = val;
              },
            },
          });
        },
      });
    },
    showMachineRepair(id) {
      this.GetMachineRepair({ id }).then((res) => {
        if (!res.status) return false;
        if (!res.data.length) {
          this.$Message.error("未设置维护人员");
          return false;
        }
        let html = "";
        res.data.map((item) => {
          html += `<p>${item.name},${item.tel}</p>`;
        });
        this.$Modal.info({
          title: "维护人员",
          content: html,
          cancelText: "",
          okText: "关闭",
        });
      });
    },
    //延续运营期
    countinueDate(row) {
      this.expire.isChangeDate = false;
      this.expire.isGetOperate = false;
      this.expire.code = "";
      this.expire.loading = false;
      this.pay_period.sn = row.sn;
      if (this.agent.tp) {
        //合作伙伴
        if (this.agent.is_activation && row.meter == 0) {
          //是否有线上购买权限并且设备类型是云知印
          this.pay_period.visible = true;
          this.pay_period.data.machine_id = row.id;
        } else {
          // 输入序列号
          this.expire.data = {};
          this.expire.code = "";
          this.expire.visible = true;
          this.expire.id = row.id;
        }
      } else {
        //运营商
        // 直接修改
        this.expire.visible = true;
        this.expire.id = row.id;
        this.expire.meter = row.meter;
        this.expire.tp = true;
        if (row.meter === 0) {
          this.expire.expire_time = row.expire_time
            ? this.$moment(row.expire_time, "YYYY-MM-DD")
            : this.$moment(row.trail_expire_time, "YYYY-MM-DD");
        } else if (row.meter === 1) {
          this.expire.expire_time = row.maintain_expire_time
            ? this.$moment(row.maintain_expire_time, "YYYY-MM-DD")
            : this.$moment(row.trail_expire_time, "YYYY-MM-DD");
        }
        this.expire.expire_time_original = this.expire.expire_time;
      }
    },
    async syncMachine() {
      this.syncStatus = true;
      this.SyncMachine().then((res) => {
        this.syncStatus = false;
        if (res.status && !res.err) {
          this.$Message[res.status ? "success" : "error"](res.msg);
          this.getData();
        } else if (res.status && res.err) {
          this.SyncMachine().then((res1) => {
            this.syncStatus = false;
            if (res1.status) {
              this.$Message[res.status ? "success" : "error"](res.msg);
              this.getData();
            }
          });
        } else {
          this.$Message[res.status ? "success" : "error"](res.msg);
        }
      });
    },
    ...mapActions([
      "getMachine",
      "socketSend",
      "initMachineInfo",
      "SetMachineDate",
      "GetOperateCode",
      "ActivateCode",
      "MachineError",
      "GetMachineConnect",
      "BuyIncrement",
      "TransferIncrement",
      "GetPayee",
      "MachineDispense",
      "SaveUserAgentDispense",
      "getSite",
      "getCharge",
      "getRepair",
      "SendTelCode",
      "CodeCheck",
      "GetMachineRenew",
      "MachineErrorList",
      "SaveMachineTrack",
      "GetMachineTrack",
      "saveMachine",
      "GetMachineRepair",
      "GetUserAgentDispense",
      "SyncMachine",
      "GetMachineLastError",
    ]),
  },
  created() {
    //获取缓存中的筛选条件
    let filter = localStorage.getItem("machine_list");
    if (filter) {
      this.search = JSON.parse(filter);
    }
  },
  mounted() {
    console.log("this.$route.params", this.$route.params);
    if (this.$route.params) {
      if (this.$route.params.network) {
        this.search.network = 0;
      }
      if (this.$route.params.agent_name) {
        this.search.select3 = "agent_name";
        this.search.val3 = this.$route.params.agent_name;
      }
    }
    this.tab_index = !this.agent.tp ? "tab1" : "tab2";
    this.searchOk();
    this.formatCol();
  },
  destroyed() {
    console.log("离开了");
    // localStorage.removeItem('machine_list')
  },
  computed: mapGetters({
    socket: "socket",
    data: "machine",
    machine_info: "machine_info",
    agent: "agent",
  }),
  watch: {
    // deep watch 查看col变动
    col: {
      handler(n, o) {
        this.formatCol();
      },
      deep: true,
    },
    "page.status"() {
      this.getData();
    },
    info(n, o) {
      if (!n) {
        this.initMachineInfo();
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
